package components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import shared.config.WebsiteSvgs

@Composable
fun ThemeSwitcher(isDark: Boolean, onToggle: () -> Unit) {
    Button(attrs = {
        style {
            padding(0.5.cssRem)
            property("color", "var(--on-surface)")
            property("transition", "opacity 0.2s")
            cursor("pointer")
            property("background", "none")
            property("border", "none")
        }
        onClick { onToggle() }
        attr("aria-label", if (isDark) "Switch to light mode" else "Switch to dark mode")
        attr("aria-live", "polite")
    }) {
        if (isDark) {
            // Sun icon - click to go light
            Span(attrs = {
                ref { element ->
                    element.innerHTML = """<svg style="width:1.5rem;height:1.5rem" fill="currentColor" viewBox="${WebsiteSvgs.VIEWBOX_24}"><path d="${WebsiteSvgs.SUN}"/></svg>"""
                    onDispose { }
                }
            })
        } else {
            // Moon icon - click to go dark
            Span(attrs = {
                ref { element ->
                    element.innerHTML = """<svg style="width:1.5rem;height:1.5rem" fill="currentColor" viewBox="${WebsiteSvgs.VIEWBOX_24}"><path fill-rule="evenodd" d="${WebsiteSvgs.MOON}" clip-rule="evenodd"/></svg>"""
                    onDispose { }
                }
            })
        }
    }
}
